export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative w-full overflow-hidden bg-black"
        >
            {/* Full-bleed background video */}
            <div className="relative w-full h-[78vh] min-h-[520px] max-h-[860px]">
                <video
                    src="/videos/hero.mp4"
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    aria-hidden
                    className="absolute inset-0 w-full h-full object-cover"
                />

                {/* Soft top fade for header legibility */}
                <div
                    aria-hidden
                    className="absolute inset-x-0 top-0 h-32 pointer-events-none"
                    style={{
                        background:
                            "linear-gradient(to bottom, rgba(255,252,245,0.55) 0%, rgba(255,252,245,0) 100%)",
                    }}
                />
                {/* Bottom fade into next section */}
                <div
                    aria-hidden
                    className="absolute inset-x-0 bottom-0 h-40 pointer-events-none"
                    style={{
                        background:
                            "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 95%)",
                    }}
                />

                {/* Scroll indicator */}
                <div
                    aria-hidden
                    className="absolute inset-x-0 bottom-10 flex justify-center pointer-events-none"
                >
                    <div className="flex flex-col items-center gap-2 text-[#1F2A23]/60">
                        <div className="w-px h-10 bg-gradient-to-b from-transparent via-[#1F2A23]/40 to-[#1F2A23]/70" />
                        <span className="text-[10px] font-semibold tracking-[0.3em] uppercase">
                            Scroll
                        </span>
                    </div>
                </div>
            </div>
        </section>
    );
}
